import { useContext } from "react"

import { RoadsideStateContext, RoadsideDispatchContext } from "./RoadsideContext.context"

export const useRoadsideStateContext = () => {
    const context = useContext(RoadsideStateContext)
    if (context === undefined) {
        throw new Error("useRoadsideStateContext must be used within an RoadsideStateContext")
    }
    return context
}

export const useRoadsideDispatchContext = () => {
    const context = useContext(RoadsideDispatchContext)
    if (context === undefined) {
        throw new Error("useRoadsideDispatchContext must be used within an RoadsideDispatchContext")
    }
    return context
}